import { STORAGE_KEYS } from "@/lib/storage-keys";

/** Bound to the ciphertext, so switching to another backup cannot inherit this restriction. */
export const INCOMPLETE_INVENTORY_KEY = "sigma:incomplete-inventory-backup";
export function hasIncompleteInventory(backup: unknown): boolean {
	return Boolean(
		backup &&
			typeof backup === "object" &&
			"format" in backup &&
			backup.format === "sigma-seed" &&
			"inventoryComplete" in backup &&
			backup.inventoryComplete === false
	);
}
export function cloudInventoryIsIncomplete(
	encrypted: string,
	storage: Pick<Storage, "getItem"> = localStorage
): boolean {
	if (storage.getItem(INCOMPLETE_INVENTORY_KEY) === encrypted) {
		return true;
	}
	if (typeof sessionStorage === "undefined") {
		return false;
	}
	try {
		return hasIncompleteInventory(
			JSON.parse(
				sessionStorage.getItem(STORAGE_KEYS.DECRYPTED_BACKUP) || "null"
			)
		);
	} catch {
		return false;
	}
}
export const INCOMPLETE_INVENTORY_MESSAGE =
	"Import your complete backup file before updating cloud backup or creating another profile. Recovery words restored only the selected profile's inventory.";
